var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "meteor-icon-kit__regular-content",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0769 24C10.4822 24 10 23.5523 10 23C10 22.4477 10.4822 22 11.0769 22H22.9231C23.5178 22 24 22.4477 24 23C24 23.5523 23.5178 24 22.9231 24H11.0769ZM11.0769 18C10.4822 18 10 17.5523 10 17C10 16.4477 10.4822 16 11.0769 16H22.9231C23.5178 16 24 16.4477 24 17C24 17.5523 23.5178 18 22.9231 18H11.0769ZM11.0769 12C10.4822 12 10 11.5523 10 11C10 10.4477 10.4822 10 11.0769 10H22.9231C23.5178 10 24 10.4477 24 11C24 11.5523 23.5178 12 22.9231 12H11.0769ZM18 6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6V3C16 2.44772 15.5523 2 15 2H3C2.44772 2 2 2.44772 2 3V15C2 15.5523 2.44772 16 3 16H6C6.55228 16 7 16.4477 7 17C7 17.5523 6.55228 18 6 18H3C1.34315 18 0 16.6569 0 15V3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V6Z",
    fill: "#758CA3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSvgrepoCom1);
export default __webpack_public_path__ + "static/media/content-svgrepo-com (1).b1e54fa97ac007d7b8acd94b747b6dbc.svg";
export { ForwardRef as ReactComponent };